import type { Scenario, ScenarioContent } from "@/lib/powtoon-be/types";
import { questionnaireIdsOfContent, roleplayIdsOfContent } from "./providers/spec";

/**
 * Where a scenario's questionnaire versions live.
 *
 * LiveAvatar keeps them on `context_block`, but the providers added since have
 * no context block of their own, so each stores them on its provider block.
 * The per-provider location is declared once in the provider spec registry;
 * this wrapper exists so callers keep a scenario-shaped entry point.
 */
export function questionnaireIdsOf(content: ScenarioContent | undefined | null): string[] {
  return questionnaireIdsOfContent(content);
}

/** Active (newest) questionnaire version id, if the scenario has one. */
export function activeQuestionnaireId(
  scenario: Pick<Scenario, "content"> | undefined | null,
): string | undefined {
  return questionnaireIdsOf(scenario?.content)[0];
}

/** Role-play artifact versions for this scenario, newest first. */
export function roleplayIdsOf(content: ScenarioContent | undefined | null): string[] {
  return roleplayIdsOfContent(content);
}

/** Active (newest) role-play artifact id, if the scenario has one. */
export function activeRolePlayId(
  scenario: Pick<Scenario, "content"> | undefined | null,
): string | undefined {
  return roleplayIdsOf(scenario?.content)[0];
}
